import { useState } from "react";
import { printNewReceiptPdf } from "../../utils/newReceiptPdf";

export default function NewReceiptPrintButton({
  buildReceipt,
  className = "",
  label = "Print New Receipt",
  disabled = false,
}) {
  const [printing, setPrinting] = useState(false);

  async function handleClick(event) {
    event.stopPropagation();
    if (disabled || printing) return;
    setPrinting(true);
    try {
      const receipt = await Promise.resolve(
        typeof buildReceipt === "function" ? buildReceipt() : buildReceipt,
      );
      if (!receipt) return;
      await printNewReceiptPdf(receipt);
    } catch (error) {
      console.error("Unable to generate the new receipt:", error);
    } finally {
      setPrinting(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled || printing}
      className={`px-3 py-1.5 text-xs font-semibold rounded-lg border border-emerald-300 text-emerald-700 hover:bg-emerald-50 disabled:opacity-60 ${className}`}
    >
      {printing ? "Printing..." : label}
    </button>
  );
}
